module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section",
    attrs: {
      "id": "section001"
    }
  }, [_c('div', {
    staticClass: "pseudo_margin_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_2"
  }), _vm._v(" "), _c('p', {
    staticClass: "poem_title"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("contents")])])])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/title_page",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Copyright",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Copyright")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/text/Foreword#fore"
    }
  }, [_c('em', [_vm._v("Foreword")])])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/text/Introduction#intro"
    }
  }, [_c('em', [_vm._v("Introduction")])])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_2"
  }), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Part01#part1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter01#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Early Spring")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("March Pasture")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Pregnant Woman Walks in the Fields")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bird Call")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yell")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Father in a Basket")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Treeful of Bird Calls")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flower")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Goats on a Desert Island")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On My Way to Grandma When I Was Little")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Olive Scent")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spring Camellias")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valley’s Green")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Expanse of Azure")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the Canyon")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fading Things")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Behind the Isle")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_2"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_x",
      "title": "x"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Part02#part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sea Summit")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sea First Man Next")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drift Bottle")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Many Many Mothers")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Own Sea")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Using Two Seas")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Dog on the Shore")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No Prop Can Shield You")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Look at the Sunset")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Red Earth")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In That Wild Mountain")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heavy Rain")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Names on the Tombstone")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter31#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("This Wind Comes Alone")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter32#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Patch of Sunlight")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter33#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Common Life")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter34#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("By the Maple Woods")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_2"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xi",
      "title": "xi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Part03#part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter35#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Porcelain Vases")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter36#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Old Tree")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter37#ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Those Days Father Repaired the Clock")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter38#ch38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sun on the First Day of the New Century")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter39#ch39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Is There Such an Eagle")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter40#ch40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spring Arrives")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter41#ch41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Bird")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter42#ch42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Bouquet of Cauliflower")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter43#ch43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marigold")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter44#ch44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carnation")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter45#ch45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Pregnant Woman")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter46#ch46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("O Water . . .")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter47#ch47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bird Call on a Spring Day")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter48#ch48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joy")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter49#ch49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They Still Have Not Emerged")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter50#ch50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Voice of Flowing Water")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter51#ch51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the Open Field")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_2"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xii",
      "title": "xii"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Part04#part4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter52#ch52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eternal")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter53#ch53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They Say")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter54#ch54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wind Comes Wind Goes")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter55#ch55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Flight of Floating Stairs")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter56#ch56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rain Pours Harder")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter57#ch57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yesterday’s Rain Joins Today’s Rain")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter58#ch58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the Form of a Scissor Cut")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter59#ch59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Aroma We Smell")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter60#ch60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Birds Have Already Flown Away")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter61#ch61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recalling Your Birth")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter62#ch62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Safety Zone")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter63#ch63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creek of Nine Tunes")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter64#ch64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Golden Butterfly")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter65#ch65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In an Instant")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter66#ch66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fairy Tale")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter67#ch67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Solitude")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter68#ch68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Because of Awakening")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_2"
  }), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Part05#part5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter69#ch69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sand Sculpture")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter70#ch70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Volcanic Stone")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter71#ch71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Eagle’s Shadow Darkens the Storm")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter72#ch72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Always a Moon Locked Inside")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter73#ch73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lake, Again")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter74#ch74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Broken Water")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter75#ch75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pit of the Stomach")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter76#ch76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Power of a Chest Cavity Is Too Weak")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter77#ch77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The World’s Heart Always Aches Faintly")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter78#ch78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Many Stars Emerge")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter79#ch79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One Day It Will Stop Completely")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter80#ch80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("That Bouquet of White Flowers")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter81#ch81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Space of Drama")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter82#ch82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Solo Dance")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter83#ch83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Only the Sun Can Do What the Sun Does")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter84#ch84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With Mount Liangye Falls")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter85#ch85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two White Houses")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Chapter86#ch86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("May You See the Splendor of Stars in This World")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_16"
  }), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/text/Author#author",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("About the Authors")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a3a7668","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Toc.vue
// module id = 75
// module chunks = 0